export function handleName(val) {
  if (!val) {
    return '';
  }
  let list = JSON.parse(sessionStorage.getItem('CREATEPOPLIST'));
  let item = list.find((item) => item.realName == val);
  return item ? item.userName : val;
}
export function loop(arr, index = '') {
  return arr.map((item, i) => {
    if (item.children && item.children != null) {
      return {
        ...item,
        key: index ? `${index}-${i + 1}` : `${i + 1}`,
        value: item.value + '_' + Math.random(),
        children: loop(item.children, index ? `${index}-${i + 1}` : `${i + 1}`),
      };
    } else {
      return {
        ...item,
        value: item.value + '_' + Math.random(),
        key: index ? `${index}-${i + 1}` : `${i + 1}`,
      };
    }
  });
}

/**
 * 根据判断条件查找树结构中的某个节点
 * @param {*} key 子节点的key
 * @param {*} tree 树结构数据
 * @param {*} condFunc 判断条件函数
 * @returns 节点对象
 */
export function findTreeNode(key, tree, condFunc) {
  if (Array.isArray(tree)) {
    for (var i in tree) {
      let r = findTreeNode(key, tree[i], condFunc);
      if (r) {
        return r;
      }
    }
  } else if ('object' == typeof tree) {
    return condFunc(tree) ? tree : findTreeNode(key, tree[key], condFunc);
  }
  return null;
}
/**
 * 根据判断条件查找树结构中的多个节点
 * @param {*} key 子节点的key
 * @param {*} tree 树结构数据
 * @param {*} condFunc 判断条件函数
 * @param {*} array 内部保存用,调用时不用传
 * @returns 节点对象
 */
export function findTreeNodeArray(key, tree, condFunc, array) {
  array = array ? array : []; //初始化数组
  if (Array.isArray(tree)) {
    tree.forEach((e) => findTreeNodeArray(key, e, condFunc, array));
  } else if ('object' == typeof tree) {
    condFunc(tree) && array.push(tree);
    findTreeNodeArray(key, tree[key], condFunc, array);
  }
  return array;
}

/**
 * 防抖
 * @param {*} func
 * @param {*} wait
 * @returns
 */
export function debounce(func, wait = 1000) {
  //可以放入项目中的公共方法中进行调用
  let timeout;
  return function (event) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.call(this, event);
    }, wait);
  };
}

/**
 * 节流函数 在规定的时间内请求函数的次数
 * @param callback  需要执行的方法
 * @param interval 执行的间隔时间
 */
export function _throttle(callback, interval) {
  let last = 0;
  let timer;
  const interVal = interval || 200;
  return function () {
    const th = this;
    const now = new Date().getTime();
    if (last && now - last < interVal) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = new Date().getTime();
      }, interVal);
    } else {
      last = new Date().getTime();
      callback(th);
    }
  };
}
